import setInboxRuleService from '../services/setInboxRuleService';
import InboxRule from 'owa-service/lib/contract/InboxRule';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import InboxRuleRetryDialog from '../components/InboxRuleRetryDialog';
import { logUsage } from 'owa-analytics';
import resetInboxRuleEdit from './resetInboxRuleEdit';
import getInboxRules from './getInboxRules';
import runRuleNow from '../actions/actionCreators/runRuleNow';
import canRunRule from 'owa-inbox-rules-option/lib/utils/canRunRule';

export default action('setInboxRuleAction', datapoints.setInboxRuleDatapoint)(
    async function setInboxRuleAction(
        inboxRule: InboxRule,
        shouldRunRuleNow: boolean,
        force?: boolean,
        alwaysDeleteOutlookRulesBlob?: boolean
    ): Promise<void> {
        return setInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob)
            .then(response => {
                if (!response.WasSuccessful) {
                    // show retry dialog if request failed and UserPrompt
                    if (response.UserPrompt) {
                        let dialog = new InboxRuleRetryDialog(
                            response.UserPrompt,
                            isChecked =>
                                setInboxRuleAction(
                                    inboxRule,
                                    shouldRunRuleNow,
                                    true /*force*/,
                                    isChecked /*alwaysDeleteOutlookRulesBlob*/
                                ),
                            () => {}
                        );
                        return dialog.show();
                    }
                    logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
                        'SetInboxRule',
                    ]);
                }
                if (shouldRunRuleNow && canRunRule(inboxRule)) {
                    runRuleNow(inboxRule, null /* sourceFolderId */, 'SetInboxRule');
                }
                resetInboxRuleEdit();
                // re-fetch the rules list if successful
                getInboxRules();
                return Promise.resolve();
            })
            .catch(error => {
                logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, ['SetInboxRule']);
                return Promise.resolve();
            });
    }
);
